module.exports = {"libs.subscriptionActivate.message.required":"Requis","libs.subscriptionActivate.message.invalidPassword":"Votre mot de passe doit comporter 8 caractères. Veuillez mettre à jour."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/libs/subscriptionActivate.json
// module id = 804
// module chunks = 0